
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Perilunate_dislocation_classification',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Perilunate_dislocation_classification.vue